<template lang="pug">
</template>

<script>
export default {
  name: 'wc-loaders-infinite-spinner',
}
</script>
